import { cn } from '@/platform/lib/utils';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

const TooltipContent = ({ className, sideOffset = 6, children, ...props }) => (
    <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
            data-slot='tooltip-content'
            sideOffset={sideOffset}
            collisionPadding={8}
            className={cn(
                'z-50 max-w-xs origin-(--radix-tooltip-content-transform-origin) rounded-lg bg-gray-900 px-2.5 py-1.5 text-xs leading-5 font-medium text-pretty text-white ring-1 shadow-lg ring-white/10 select-none',
                'animate-in fade-in-0 zoom-in-95 duration-150',
                'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
                'data-[side=top]:slide-in-from-bottom-1 data-[side=bottom]:slide-in-from-top-1 data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1',
                className
            )}
            {...props}
        >
            {children}
            <TooltipPrimitive.Arrow
                width={10}
                height={5}
                className='fill-gray-900'
            />
        </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
);

export default TooltipContent;
